const FIRST_NAME_REQUIRED = "First name is required.";
const LAST_NAME_REQUIRED = "Last name is required.";
const GENDER_REQUIRED = "Gender is required.";
const EMAIL_REQUIRED = "Email is required.";
const PASSWORD_REQUIRED = "Password is required.";
const ADDRESS_REQUIRED = "Address is required.";
const MOBILE_REQUIRED = "Mobile is required.";
const CONFIRM_PASSWORD_REQUIRED = "Please confirm your password.";
const CONFIRM_PASSWORD_NO_MATCH =
  "Confirmed password doesnot match the passowrd";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  FIRST_NAME_REQUIRED,
  LAST_NAME_REQUIRED,
  GENDER_REQUIRED,
  EMAIL_REQUIRED,
  ADDRESS_REQUIRED,
  MOBILE_REQUIRED,
  PASSWORD_REQUIRED,
  CONFIRM_PASSWORD_REQUIRED,
  CONFIRM_PASSWORD_NO_MATCH,
};
